var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.47762889,-0.872821427 L7.07216051,2.1408283 C7.23859979,2.28037073 7.26040399,2.52841791 7.12086155,2.69485719 C7.10608336,2.71248389 7.0897872,2.72878005 7.07216051,2.74355824 C6.96053464,2.83714519 6.82149677,2.88049073 6.68447872,2.87359485 C6.67982023,2.95163195 6.64987508,3.03010834 6.59475582,3.09585185 C6.57997762,3.11347855 6.56368146,3.12977471 6.54605477,3.1445529 L2.95152315,6.15820262 C2.74359262,6.33253126 2.44054737,6.33253126 2.23261683,6.15820262 C2.06617755,6.01866019 2.04437335,5.770613 2.18391578,5.60417372 C2.19869398,5.58654703 2.21499014,5.57025087 2.23261683,5.55547268 L5.82714845,2.54182295 C5.87883572,2.49848842 5.93640031,2.46592596 5.99692025,2.44413559 L2.75872257,-0.270091482 C2.59228329,-0.409633915 2.57047909,-0.657681101 2.71002152,-0.824120379 C2.72479972,-0.841747074 2.74109588,-0.858043234 2.75872257,-0.872821427 C2.96665311,-1.04715007 3.26969836,-1.04715007 3.47762889,-0.872821427 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Conversation-with-gift-sent",
    transform: "translate(-258.000000, -494.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(245.000000, 483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift",
    transform: "translate(13.000000, 11.408163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9520821,19.5533082 L3.08739263,19.5533082 C2.40926794,19.5516567 1.85990353,19.0024266 1.85808618,18.3243023 L1.85808618,8.56889902 C1.85808618,8.40290215 1.99265323,8.2683351 2.1586501,8.2683351 L18.8808246,8.2683351 C19.0468215,8.2683351 19.1813885,8.40290215 19.1813885,8.56889902 L19.1813885,18.3243023 C19.1795712,19.0024266 18.6302068,19.5516567 17.9520821,19.5533082 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5802607,8.86946295 L18.5802607,18.3243023 C18.5799296,18.6711472 18.2989268,18.9522845 17.9520821,18.9527815 L17.9520821,18.9527815 L3.08769319,18.9527815 C2.74073109,18.9524501 2.45954542,18.6712644 2.45921403,18.3243023 L2.45921403,18.3243023 L2.45921403,8.86946295 L18.5802607,8.86946295 Z M9.11,8.87183673 L8.51,8.87183673 L8.51,18.9518367 L9.11,18.9518367 L9.11,8.87183673 Z M12.6,8.87183673 L12,8.87183673 L12,18.9518367 L12.6,18.9518367 L12.6,8.87183673 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2742389,8.86946295 L0.765235751,8.86946295 C0.343096594,8.86913241 0.00082824439,8.52726736 0,8.10512889 L0,5.78176975 C0.000497170224,5.35939648 0.342862321,5.0171658 0.765235751,5.01683456 L20.2742389,5.01683456 C20.6966124,5.0171658 21.0389775,5.35939648 21.0394747,5.78176975 L21.0394747,8.10512889 C21.0386465,8.52726736 20.6963781,8.86913241 20.2742389,8.86946295 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.765235751,5.61796241 C0.674718707,5.61796241 0.601127849,5.69125286 0.601127849,5.78176975 L0.601127849,8.10512889 C0.601127849,8.19564578 0.674718707,8.26893622 0.765235751,8.26893622 L20.2742389,8.26893622 C20.364756,8.26893622 20.4383468,8.19564578 20.4383468,8.10512889 L20.4383468,5.78176975 C20.4383468,5.69125286 20.364756,5.61796241 20.2742389,5.61796241 L0.765235751,5.61796241 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(6.530612, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#FFFFFF",
    strokeWidth: 0.9,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    transform: "translate(4.652389, 2.642691) rotate(90.000000) translate(-4.652389, -2.642691) ",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift);
export default __webpack_public_path__ + "static/media/icGift.21762e141f53b6e21132f039c369e31c.svg";
export { ForwardRef as ReactComponent };